"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModal = exports.ModalGlobalStyle = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _ModalGlobalStyleMixin = require("../../mixins/components/ModalGlobalStyleMixin");
var StyledModal = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledModal",
  componentId: "c11n-8-107-0__sc-1rx4oah-0"
})([""]);
exports.StyledModal = StyledModal;
var ModalGlobalStyle = /*#__PURE__*/(0, _styledComponents.createGlobalStyle)(["", ""], _ModalGlobalStyleMixin.ModalGlobalStyleMixin);
exports.ModalGlobalStyle = ModalGlobalStyle;